import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class Vehicle {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }

    updateVehicle(vehNo) {
        const srv = this;
        const elems = this.ctx.getters.funnel.elements;
        var vehUids = {};
        var payload = {};
        const uids = Object.keys(elems);
        vehUids = uids.filter(function (uid) {
            if (elems[uid].value != '' &&
                uid.indexOf(srv.vehNoStr(vehNo)) != -1 &&
                !Utils.isTruthy(elems[uid].hidden)
            ) {
                return true;
            }
            return false;
        });
        for (const uid of vehUids) {
            payload[uid] = { value: elems[uid].value };
        }
        return payload;
    }

    addVehicle(e, input) {
        if (this.ctx.getters.factory.saving != true) {
            console.log('vehicle-service: addVehicle.');
            let resetLoader = false;
            if (this.processVehicleMaxLimit(false)) {
                resetLoader = true;
            } else {
                if (this.validateVehicles()) {
                    this.ctx.dispatch('createVehicleElem', { payload: {} });
                } else {
                    resetLoader = true;
                }
            }

            if (resetLoader)
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_new_vehicle', key: 'loading', val: false });
        }
    }

    vehicleActionBtns(e, input) {
        const func = (e.type == 'change') ? e.target.value.toLowerCase() : e.target.id;
        const fxn = `${func}Vehicle`;
        eval(`this.${fxn}(e, input)`);
    }

    editVehicle(e, elem) {
        if (this.ctx.getters.factory.saving != true) {
            const uid = 'in_veh_opType';
            const vOpType = this.ctx.getters.funnel.elements[uid].value;
            if (vOpType == '' || vOpType == 'edit') {
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: 'edit' });
                const vehNo = elem.uid.split('_').pop();
                this.createVehicleAdHocSeq(vehNo);
                this.processVehicleMaxLimit();
                this.ctx.dispatch('editVehicleElem', { payload: elem });
            }
        }
    }

    createVehicleAdHocSeq(ctxVehNo) {
        const vsPuid = `pg_vehicles_start_${ctxVehNo}`;
        const vDpuid = `pg_vehicles_details_${ctxVehNo}`;
        const srcPuid = 'pg_vehicles_summary';

        const srcPage = {
            'puid': srcPuid,
            'route': this.ctx.getters.funnel.elements[srcPuid].page_route
        };
        var pagesObj = {};
        pagesObj[vsPuid] = this.ctx.getters.funnel.elements[vsPuid].page_route;
        pagesObj[vDpuid] = this.ctx.getters.funnel.elements[vDpuid].page_route;

        this.fs.createAdHocSeq(srcPage, pagesObj);
    }

    keepVehicle(e, elem) {
        const count = this.getCountOnPickedVehicles();
        const vsuid = 'pg_vehicles_start_1';
        const vehStartIndx = this.ctx.getters.funnel.idsMap.pages_sequence.indexOf(vsuid);

        this.processVehicleMaxLimit(false, count - 1);

        if (count == 1 || vehStartIndx != -1) {
            const btnText = this.ctx.getters.factory.initElements[vsuid].button_text;
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_vehicles_details_1', key: 'button_text', val: btnText });
            this.ctx.commit('DELETE_PAGE_SEQ', [vsuid]);
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: vsuid, key: 'page_complete', val: true });
            this.fs.processComplete(vsuid);
        }
    }

    removeVehicle(e, elem) {
        const count = this.getCountOnPickedVehicles();

        this.processVehicleMaxLimit(false, count - 1);

        if (count == 0) {
            const btnText = this.ctx.getters.factory.initElements.pg_vehicles_details_1.button_text;
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_vehicles_details_1', key: 'button_text', val: btnText });

            const vehStartIndx = this.ctx.getters.funnel.idsMap.pages_sequence.indexOf('pg_vehicles_start_1');
            if (vehStartIndx == -1) {
                const vehDtlsIndx = this.ctx.getters.funnel.idsMap.pages_sequence.indexOf('pg_vehicles_details_1');
                this.ctx.commit('ADD_PAGE_SEQ', { i: vehDtlsIndx, puid: 'pg_vehicles_start_1' });
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_vehicles_start_1', key: 'page_complete', val: false });
                this.fs.processComplete('pg_vehicles_start_1');
            }
        }
    }

    getCountOnPickedVehicles() {
        let keepCnt = 0;
        const prefillVehicles = this.getVehicleElems('prefill');
        if (prefillVehicles.length > 0) {
            for (const vuid of prefillVehicles) {
                const vehPref = this.ctx.getters.funnel.elements[vuid];
                if (vehPref.value == 'Keep')
                    keepCnt++
            }
        }
        return keepCnt;
    }

    validateVehicles() {
        const vehicles = this.getVehicleElems();
        var isValid = false;
        var inValidVehs = [];
        var veh = {};
        for (const uid of vehicles) {
            Object.assign(veh, this.ctx.getters.funnel.elements[uid]);
            veh.id = `${veh.id}-id`;
            if (!this.fs.isValid(veh)) {
                inValidVehs.push(uid);
            }
        }
        isValid = inValidVehs.length == 0;
        return isValid;
    }

    getVehicleElems(type = 'summary') {
        const inSeqLen = this.fs.getPageInputSeqBySuid(`pg_vehicles_${type}`, `sc_vehicles_${type}`);
        var fltrStr = type == 'summary' ? '' : 'prefill_';
        fltrStr = `in_${fltrStr}vehicle_`;
        return inSeqLen.filter(this.fs.checkStrMatch, { ctrl: fltrStr });
    }

    getVehiclesCount() {
        let vehsCount = 0;
        const vehMatches = this.getVehicleElems();
        if (vehMatches) {
            vehsCount = vehMatches.length;
        }
        console.log('No. of Vehs:', vehsCount);
        return vehsCount;
    }

    deleteVehicle(e, elem) {
        if (this.ctx.getters.factory.saving != true) {
            console.log('Deleting vehicle.');
            this.processVehicleMaxLimit();
            this.ctx.dispatch('deleteVehicleElem', { payload: elem });
        }
    }

    startVehiclePrefill(e, input) {
        //e.preventDefault();
        console.log('Event obj is:', e);
        console.log('FormInput ...', input);
        //this.ctx.dispatch('processVehiclePrefill');
    }

    pg_vehicles_prefill(payload) {
        console.log('BL for pg_vehicles_prefill: ', payload);
        this.setVehDamageExistsStatusFlag();
    }

    processVehicleMaxLimit(rst = true, vehCount = this.getVehiclesCount()) {
        let isVehMxLim = false;
        const uid = 'in_is_vehicle_max_limit_reached';
        const lim = this.ctx.getters.funnel.elements[uid].data.max;
        if (vehCount >= lim) {
            isVehMxLim = true;
        }
        isVehMxLim = rst && isVehMxLim ? !rst : isVehMxLim;

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: isVehMxLim });
        return isVehMxLim;
    }

    pg_vehicles_start(payload) {
        console.log('BL for pg_vehicles_start: ', payload);
        this.setVehDamageExistsStatusFlag();
        return;
    }

    pg_vehicles_details(payload) {
        console.log('BL for pg_vehicles_details: ', payload);
        const vehNo = this.ctx.getters.funnel.elements['in_veh_no'].value;
        this.fs.showTwinButtonCardLoader('vehicle', vehNo);
        return;
    }

    onAcciDamageToggleDamageExists(e, input) {
        this.setVehDamageExistsStatusFlag(input.value);
    }

    setVehDamageExistsStatusFlag(acciDamage = '') {
        const uid = 'in_flg_sc_veh_details_damage_exists';
        const adUid = 'in_accident_damage';
        const adqUid = 'in_accident_damage_question';
        const elems = this.ctx.getters.funnel.elements;

        acciDamage = !Utils.isEmpty(acciDamage) ? acciDamage : elems[adUid].value;
        const acciDamageQFlag = elems[adqUid].value;
        let status = false;
        if (acciDamage.toLowerCase() == 'yes' || !Utils.isTruthy(acciDamageQFlag)) {
            status = true;
        }
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: status });
    }

    pg_vehicles_summary(payload) {
        return;
    }

    resetMasking(e, input) {
        if (Utils.isTruthy(input.basic)) {
            let elem = {};
            elem[input.uid] = Object.assign({}, this.ctx.getters.factory.vehicleDF.veh[input.uid]);
            this.ctx.commit('ADD_ELEMENTS', elem);
        }
    }

    startVINLookUp(e, input) {
        const vin = this.ctx.getters.funnel.elements['in_vin'];
        if (this.fs.isValid(vin)) {
            this.resetVINLookUpError();
            this.ctx.dispatch('processVINValidate', { vin: vin.value });
        }
    }

    resetVINLookUp(e, input) {
        const uid = 'in_vin_fetch_matches';
        if (Utils.isEmpty(e.target.value)) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: 'discover' });
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'options', val: [] });
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        }
    }

    update(e, input) {
        const field = input.id.split('in_')[1]; //input.id.split('-')[0];
        //const vehNo = input.element_no;
        const veh = {};
        const vfields = [...this.ctx.getters.ymmt, ...['vin']];

        for (const vf of vfields) {
            veh[vf] = this.ctx.getters.funnel.elements[`in_${vf}`].value; // this.vehField(vehNo, vf)
        }
        this.vinDiscovery(field, veh);
    }

    vinDiscovery(field, veh) { // field, vehNo, veh
        var payload = this.createVINDiscoveryPayload(field, veh);
        if (payload) {
            this.ctx.dispatch('processVINDiscovery', payload);
        }
    }

    resetVehFieldAndOptions(payload) {
        /* If current value is not in the returned array reset current value.
        For a vehicle, if a value is set for the requested resource and the value is contained in the
        resource result set (the options), there is no need to reset the value and options otherwise
        reset. */
        //const vehicle = new Vehicle({ ctx: context });
        var field = payload.req.rsrc;
        var options = payload.res;
        var iuid = this.vehPropStr(field);

        if (this.ctx.getters.ymmtCtrl.length > 0) {
            for (const vf of this.ctx.getters.ymmtCtrl) {
                const vfIuid = this.vehPropStr(vf);
                var rstNxtFVal = this.ctx.getters.funnel.elements[vfIuid].value;
                if (rstNxtFVal != '' && Array.isArray(options) && options.indexOf(rstNxtFVal) != -1 && vf == payload.req.rsrc) {
                    break;
                } else {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: vfIuid, key: 'value', val: '' });
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: vfIuid, key: 'options', val: Utils.buildSelectOptions() });
                }
            }
        }
        if (field != 'vehicle_detail') {
            var optsObjs = options;
            if (!Utils.isObjEmpty(options) && typeof options[0] != 'object') {
                if (field == 'trim') {
                    optsObjs = Utils.buildSelectOptions(options, true, true, true);
                } else {
                    optsObjs = Utils.buildSelectOptions(options);
                }
            }
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: iuid, key: 'options', val: optsObjs });
        }
    }

    createVINDiscoveryPayload(vfield, veh) { // vfield, vehNo, veh
        /* For the field that changed in YMMT waterfall collect values of the previous fields if any
        and build the request payload; also take note of subsequent fields to be reset if any.
        */
        console.log('Ymmt', this.ctx.getters.ymmt);
        var rscIndx = this.ctx.getters.ymmt.indexOf(vfield);
        var resource = this.ctx.getters.ymmt[rscIndx + 1];
        var pd = null;
        var params = {};
        this.ctx.commit('resetYmmtCtrl');
        console.log(`${vfield} for the veh changed get ${vfield == 'trim' ? 'vehicle_detail' : resource}`);

        params = this.buildReqParamsAndResetFields(rscIndx, veh);

        if (vfield == 'trim') {
            params = {};
            resource = 'vehicle_detail';
            params['partial_vin'] = veh[vfield].split('|')[1];
        }

        if (!Utils.isEmpty(resource)) {
            pd = { rsrc: resource, fields: params, veh: veh };
            //pd = { vehNo: vehNo, rsrc: resource, fields: params, veh: veh };
        }
        console.log('VIN discovery payload is:', pd);
        return pd;
    }

    buildReqParamsAndResetFields(rscIndx, veh) {
        var ctx = this.ctx;
        var params = {};
        var fields = [];
        fields = this.ctx.getters.ymmt.filter(function (vf, index) {
            if (index <= rscIndx) {
                return true;
            }
            ctx.commit('addYmmtCtrl', vf);
            return false;
        });
        this.ctx.commit('addYmmtCtrl', 'vin, partial_vin');

        for (const field of fields) {
            if (veh[field] != '') {
                params[field] = veh[field];
            } else {
                break;
            }
        }
        return params;
    }

    createVehObj(vehNo = null) {
        if (vehNo == null) {
            vehNo = Object.keys(this.ctx.getters.vehicles).length + 1;
        }
        const veh = $.extend({}, this.ctx.rootGetters.widgets.vehW.objTemplates.veh);
        this.ctx.commit('addVehicle', { vehNo: vehNo, veh: veh });
    }

    setVehicleDetail(vehDtlsElems) {
        console.log('setVehicleDetail: ', vehDtlsElems);
        for (const iuid in vehDtlsElems) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: iuid, key: 'value', val: vehDtlsElems[iuid]['value'] });
        }
    }

    isVehSet(veh) {
        if (!Utils.isEmpty(veh) && Object.keys(veh).length > 0) {
            for (const field of this.ctx.getters.ymmt) {
                if (Utils.isEmpty(veh[field])) {
                    return false;
                }
            }
        } else {
            return false;
        }
        return true;
    }

    vehNoStr(vehNo) {
        return `in_vehicles_${vehNo}`;
    }

    vehPropStr(vfield) {
        return `in_${vfield}`;
    }

    vinToggleNextButton(e, input) {
        const uid = 'in_vin_fetch_matches';
        const hasNoVehicleMatches = this.ctx.getters.funnel.elements[uid].options.length == 0;

        if (e.target.id === 'in_vehicle_lookup_mode_option_0' && hasNoVehicleMatches) {
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        } else {
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        }
    }

    vinSelectVehicle(e, input) {
        if (e.target.checked) {
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        } else {
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        }
    }

    resetVINLookUpError() {
        const uid = 'in_vin_fetch_matches';
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: 'discover' });
    }

    checkIfVehIsNew(e, input) {
        const uid = 'in_newvehdate';
        const flgUid = 'in_is_veh_new';
        const today = new Date();
        const thisYear = today.getFullYear();
        const vehYear = this.ctx.getters.funnel.elements['in_year']['value'];
        const isNewVeh = ((thisYear - vehYear) <= 1 || e.target.value == 'new');
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: flgUid, key: 'value', val: isNewVeh });

        if (!isNewVeh) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: '' });
        }
    }

}
